import { Field, InputType } from 'type-graphql'
import { ActionArgs } from '@ztechapps/common.contract'
import type { AppSetting, IAction } from '@ztechapps/common.contract'

@InputType()
export class SetHaulerTemplateArgs extends ActionArgs {
  /** The template definition JSON, stored verbatim as the tenant `hauler.template` value. */
  @Field(() => String, { nullable: false })
  value: string
}

export interface ISetHaulerTemplate extends IAction<AppSetting, SetHaulerTemplateArgs> {}
